import { HttpErrorResponse } from '@angular/common/http';
import keys from 'lodash-es/keys';
import { camelToSnakeCase } from '@shared/utils/camel-to-snake.util';
import { ValidationErrors } from '@shared/classes/ValidationErrors';
import { FormGroup } from '@angular/forms';

export function parseBackendValidationErrors(errorResponse: HttpErrorResponse): ValidationErrors {
  const errors = errorResponse?.error?.errors;

  if (!errors) {
    return {};
  }

  const errorMap: ValidationErrors = {};

  keys(errors).forEach((field) => {
    errorMap[field] = keys(errors[field]).map((key) => {
      const lowerCaseString = key.charAt(0).toLowerCase() + key.substring(1);
      return camelToSnakeCase(lowerCaseString);
    });
  });

  return errorMap;
}

export function addValidationErrorsToForm(form: FormGroup, errors: ValidationErrors): void {
  keys(errors).forEach((error: string) => {
    const control = form.get(error);
    if (control) {
      const controlErrorObject = {};
      errors[error].forEach((errorName) => {
        controlErrorObject[errorName] = errorName;
      });
      control.setErrors(controlErrorObject);
    }
  });
  form.markAllAsTouched();
  form.updateValueAndValidity();
}
